import { getAdminOrganisationByOrganisationIdGroup, getAdminOrganisationByOrganisationIdUser } from '@modv/sdk'

const state = {
  groups: [],
  users: [],
  groupsLoading: false
}
const getters = {}
const mutations = {
  set_groups_loading: (state, val) => {
    state.groupsLoading = val
  },
  GET_GROUPS: (state, res) => {
    res.data.data.forEach((element) => {
      element.isSelect = false
      element.entityType = 'group'
    })
    state.groups = res.data.data
  },
  GET_USERS: (state, res) => {
    state.users = res.data.data
  },
  ADD_GROUP: (state, res) => {
    state.groups.push(res)
    state.total++
  },
  UPDATE_GROUP: (state, res) => {
    const group = state.groups.filter((x) => x._id === res.groupId)[0]
    group.name = res.group.name
  },
  REMOVE_GROUP: (state, res) => {
    const groupIndex = state.groups.findIndex((x) => x._id === res.groupId)
    state.groups.splice(groupIndex, 1)
    state.total--
  },
  SET_GROUP_SELECT: (state, gro) => {
    if (state.groups) {
      state.groups.forEach((group) => {
        if (group._id === gro._id) {
          group.isSelect = true
        }
      })
    }
  }
}
const actions = {
  async getGroups({ commit }, params) {
    commit('set_groups_loading', true)
    commit(
      'GET_GROUPS',
      await getAdminOrganisationByOrganisationIdGroup({
        organisationId: params.organisationId
      })
    )
    commit('set_groups_loading', false)
  },
  async getUsers({ commit }, params) {
    commit('set_groups_loading', true)
    commit(
      'GET_USERS',
      await getAdminOrganisationByOrganisationIdUser({
        organisationId: params.organisationId,
        groupId: params.groupId
      })
    )
    commit('set_groups_loading', false)
  },
  addGroup({ commit }, params) {
    commit('ADD_GROUP', {
      group: params.data.data
    })
  },
  removeGroup({ commit }, params) {
    commit('REMOVE_GROUP', {
      groupId: params.groupId
    })
  },
  updateGroup({ commit }, params) {
    commit('UPDATE_GROUP', params)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
